import SingleImage from "./SingleImage";
import Modal from "react-modal";
import ModalHeader from "react-bootstrap/esm/ModalHeader";
import { ModalBody } from "react-bootstrap";
import CrossButton from "../../Common/CrossButton";

import "./SmallImages.css";
import { useState } from "react";

// import Swiper core and required modules
import {Zoom, Pagination, FreeMode } from "swiper";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";

// Import Swiper styles
import "swiper/swiper-bundle.min.css";
import "swiper/modules/navigation/navigation.min.css";
import "swiper/modules/zoom/zoom.min.css";

function SmallImages({ images }) {
  const [showFsSlider, setShowFsSlider] = useState(false);

  const toggle = () => {
    setShowFsSlider(!showFsSlider);
  };

  const customStyles = {
    overlay: { zIndex: "999999", backgroundColor: "rgb(0 0 0 / 75%)" },
    content: {overflow: "unset"},
  };

  return (
    <div>
      <section>
        <div className="collection-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-5 col-sm-10 col-xs-12">
                <Swiper
                  watchOverflow={true}
                  // watchSlidesVisibility={true}
                  watchSlidesProgress={true}
                  preventInteractionOnTransition={true}
                  spaceBetween={10}
                  centeredSlides={true}
                  pagination={true}
                  // loop={true}
                  modules={[FreeMode, Pagination]}
                  effect="fade"
                  fadeEffect={{ crossFade: true }}
                  className="mySwiper"
                >
                  {images.map((image, index) => (
                    <SwiperSlide key={index}>
                      <div key={index} onClick={toggle}>
                        <SingleImage
                          src={image.src}
                          className="img-fluid image_zoom_cls-0"
                        />
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </section>

      {showFsSlider && (
        <Modal
          isOpen={showFsSlider}
          toggle={toggle}
          style={customStyles}
          onRequestClose={() => setShowFsSlider(false)}
          shouldCloseOnOverlayClick={true}
          id="product-slider-modal"
        >
          <ModalHeader>
            <CrossButton onClick={toggle} />
          </ModalHeader>

          <ModalBody>
            <Swiper
              watchOverflow={true}
              // watchSlidesVisibility={true}
              watchSlidesProgress={true}
              preventInteractionOnTransition={true}
              spaceBetween={10}
              centeredSlides={true}
              pagination={true}
              loop={true}
              zoom={true}
              modules={[Zoom, Pagination]}
              effect="fade"
              fadeEffect={{ crossFade: true }}
              className="mySwiper product-right-slick"
            >
              {images.map((image, index) => (
                <SwiperSlide key={"slider2-" + index}>
                  <div className="swiper-zoom-container">
                    <SingleImage
                      src={image.src}
                      className="img-fluid image_zoom_cls-0"
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </ModalBody>
        </Modal>
      )}
    </div>
  );
}

export default SmallImages;
